<template>
    <div>
        <div class="row mt-3">
            <div class="col-12">
                <p class="text-danger"><b>Please use ONLY alphanumerical characters. Special, non-english ABC characters are forbidden.</b></p>
                <p class="text-danger"><b>Please double check GB EORI numbers on the following link: <a href="https://www.tax.service.gov.uk/check-eori-number" target="_blank" class="text-danger">https://www.tax.service.gov.uk/check-eori-number</a></b></p>
            </div>
        </div>
        <div class="row mt-3" v-if="ensNumber !== ''">
            <div class="col-12">
                <h4>Customer reference: {{ ensNumber }}</h4>
            </div>
        </div>
        <div v-if="step === 1" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('New ENS') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Vehicle number') }}</label>
                                    <div class="form-group">
                                        <span class="la la-truck form-icon"></span>
                                        <input v-model="vehicleNumber" v-alphanumeric-uppercase class="form-control" :class="errors.includes('vehicleNumber') ? 'is-invalid' : ''" type="text" name="vehicle_number">
                                        <div class="invalid-feedback" v-if="errors.includes('vehicleNumber')">
                                            The {{ __('Vehicle number') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Trailer number') }}</label>
                                    <div class="form-group">
                                        <span class="la la-truck form-icon"></span>
                                        <input v-model="trailerNumber" v-alphanumeric-uppercase class="form-control" type="text" name="trailer_number">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Do you have a container number?') }}</label>
                                </div>
                                <div class="form-check">
                                    <input v-model="hasContainerNumber" value="1" class="form-check-input" type="radio" name="hasContainerNumber"
                                           id="flexRadioDefault1">
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        {{ __('Yes') }}
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input v-model="hasContainerNumber" value="0" class="form-check-input" type="radio" name="hasContainerNumber"
                                           id="flexRadioDefault2" checked>
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        {{ __('No') }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box" v-if="hasContainerNumber == 1">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Container number') }}</label>
                                    <div class="form-group">
                                        <span class="la la-box form-icon"></span>
                                        <input v-model="containerNumber" class="form-control" :class="errors.includes('containerNumber') ? 'is-invalid' : ''" type="text" name="container_number">
                                        <div class="invalid-feedback" v-if="errors.includes('containerNumber')">
                                            The {{ __('Container number') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Nationality of vehicle') }}</label>
                                    <div class="form-group">
                                        <select name="nationality_of_vehicle" class="form-control" :class="errors.includes('nationalityOfVehicle') ? 'is-invalid' : ''"  v-model="nationalityOfVehicle">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('nationalityOfVehicle')">
                                            The {{ __('Nationality of vehicle') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Ferry/Eurotunnel crossing') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" :class="errors.includes('ferryEurotunnelCrossing') ? 'is-invalid' : ''" name="ferry_eurotunnel_crossing" v-model="ferryEurotunnelCrossing">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="route in routes" :value="route.id" >{{ route.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('ferryEurotunnelCrossing')">
                                            The {{ __('Ferry/Eurotunnel crossing') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box">
                                    <label class="label-text font-weight-bold">{{ __('Unaccompanied trailer') }}</label>
                                    <div class="form-check">
                                        <input v-model="unaccompaniedTrailer" value="1" class="form-check-input" type="radio" name="unaccompaniedTrailer"
                                               id="flexRadioDefault1">
                                        <label class="form-check-label" for="flexRadioDefault1">
                                            {{ __('Yes') }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="unaccompaniedTrailer" value="0" class="form-check-input" type="radio" name="unaccompaniedTrailer"
                                               id="flexRadioDefault2" checked>
                                        <label class="form-check-label" for="flexRadioDefault2">
                                            {{ __('No') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 2" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Carrier') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-12 responsive-column">
                                <div class="input-box">
                                    <label class="label-text font-weight-bold">&nbsp;</label>
                                    <div class="form-group w-75 d-inline-block">
                                        <select class="form-control" :class="errors.includes('carrier') ? 'is-invalid' : ''" name="carrier" v-model="carrier">
                                            <option value="0">{{ __('Choose') }}</option>
                                            <option v-for="company in carriers" :value="company.id">{{ company.eori_number }} - {{ company.name }} | {{ company.postcode }} {{ company.city }} {{ company.address }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('carrier')">
                                            The {{ __('Carrier') }} field is required.
                                        </div>
                                    </div>
                                    <button class="theme-btn theme-btn-small theme-btn-gray" @click="addNewCarrier">+</button>
                                </div>
                            </div>
                            <div class="col-lg-12 responsive-column" v-if="newCarrier">
                            <div class="row">
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label class="label-text font-weight-bold">{{ __('Company name') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <input class="form-control" v-alphanumeric-space :class="errors.includes('carrier_company_name') ? 'is-invalid' : ''" v-model="carrier_company_name"  type="text" name="company_name" >
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_company_name')">
                                                The {{ __('Company name') }} field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label class="label-text required font-weight-bold">{{ __('Country') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <select class="form-control" :class="errors.includes('carrier_country') ? 'is-invalid' : ''" name="carrier_country" v-model="carrier_country">
                                                <option value="">{{ __('Choose') }}</option>
                                                <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                            </select>
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_country')">
                                                The {{ __('Country') }} field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label
                                            class="label-text font-weight-bold">{{ __('Postcode') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <input class="form-control" v-alphanumeric-space :class="errors.includes('carrier_postcode') ? 'is-invalid' : ''" type="text" v-model="carrier_postcode" name="carrier_postcode">
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_postcode')">
                                                The {{ __('Postcode') }} field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label
                                            class="label-text font-weight-bold">{{ __('Address line 1') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <input class="form-control" v-alphanumeric-space-dash :class="errors.includes('carrier_address') ? 'is-invalid' : ''" type="text" v-model="carrier_address" name="carrier_address">
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_address')">
                                                The {{ __('Address line 1') }} field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label
                                            class="label-text  font-weight-bold">{{ __('Town/City') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <input class="form-control" v-alphanumeric-space :class="errors.includes('carrier_city') ? 'is-invalid' : ''" type="text" v-model="carrier_city" name="carrier_city">
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_city')">
                                                The {{ __('Town/City') }} field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 responsive-column">
                                    <div class="input-box required">
                                        <label
                                            class="label-text font-weight-bold">{{ __('EORI number') }}</label>
                                        <div class="form-group">
                                            <span class="la la-box form-icon"></span>
                                            <input class="form-control" :class="errors.includes('carrier_eori_number') ? 'is-invalid' : ''" type="text" v-model="carrier_eori_number" name="container_number">
                                            <div class="invalid-feedback" v-if="errors.includes('carrier_eori_number')">
                                                The {{ __('EORI number') }} field is required or invalid.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 responsive-column">
                                    <div class="input-box text-right">
                                        <button class="theme-btn theme-btn-gray" @click="cancelNewCarrier">{{ __('Cancel') }}</button>
                                        <button class="theme-btn theme-btn-success ml-3" @click="saveCarrier">{{ __('Save') }}</button>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 3" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Place of loading') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Loading country') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" :class="errors.includes('loadingCountry') ? 'is-invalid' : ''" v-model="loadingCountry" name="loading_country">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('loadingCountry')">
                                            The {{ __('Loading country') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Loading postcode') }}</label>
                                    <div class="form-group">
                                        <span class="la la-envelope form-icon"></span>
                                        <input class="form-control" v-alphanumeric-space :class="errors.includes('loadingPostcode') ? 'is-invalid' : ''" v-model="loadingPostcode" type="text" name="loading_postcode">
                                        <div class="invalid-feedback" v-if="errors.includes('loadingPostcode')">
                                            The {{ __('Loading postcode') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Loading city') }}</label>
                                    <div class="form-group">
                                        <span class="la la-address-card form-icon"></span>
                                        <input class="form-control" v-alphanumeric-space :class="errors.includes('loadingAddress') ? 'is-invalid' : ''" v-model="loadingAddress" type="text" name="loading_address">
                                        <div class="invalid-feedback" v-if="errors.includes('loadingAddress')">
                                            The {{ __('Loading city') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 4" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Place of unloading') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Unloading country') }}</label>
                                    <div class="form-group">
                                        <select class="form-control"  :class="errors.includes('unloadingCountry') ? 'is-invalid' : ''" v-model="unloadingCountry" name="unloading_country" >
                                            <option value="gb">GB - UNITED KINGDOM</option>
                                            <option value="ie">IE - Ireland</option>
                                            <option value="xi">XI - Northern Island</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('loadingCountry')">
                                            The {{ __('Unloading country') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Unloading postcode') }}</label>
                                    <div class="form-group">
                                        <span class="la la-envelope form-icon"></span>
                                        <input class="form-control" v-alphanumeric-space :class="errors.includes('unloadingPostcode') ? 'is-invalid' : ''" v-model="unloadingPostcode" type="text" name="unloading_postcode">
                                        <div class="invalid-feedback" v-if="errors.includes('unloadingPostcode')">
                                            The {{ __('Unloading postcode') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Unloading city') }}</label>
                                    <div class="form-group">
                                        <span class="la la-address-card form-icon"></span>
                                        <input class="form-control" v-alphanumeric-space :class="errors.includes('unloadingAddress') ? 'is-invalid' : ''" v-model="unloadingAddress" type="text" name="unloading_address">
                                        <div class="invalid-feedback" v-if="errors.includes('unloadingAddress')">
                                            The {{ __('Unloading city') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 5" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Countries of routing') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Dispatch country') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" :class="errors.includes('dispatchCountry') ? 'is-invalid' : ''" v-model="dispatchCountry" name="dispatch_country">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('dispatchCountry')">
                                            The {{ __('Dispatch country') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box">
                                    <label class="label-text font-weight-bold">{{ __('Countries of transit') }}</label>
                                    <div class="form-group w-75 d-inline-block" v-for="(transitCountry,index) in transitCountries">
                                        <select class="form-control"  :class="errors.includes('transitCountries') ? 'is-invalid' : ''" name="country" v-model="transitCountries[index]">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                        </select>
                                        <button v-if="index > 0" class="theme-btn theme-btn-small theme-btn-gray" @click="removeTransitCountry(index)">-</button>
                                    </div>
                                    <button class="theme-btn theme-btn-small theme-btn-gray" @click="addTransitCountry">+</button>
                                    <div class="invalid-feedback" v-if="errors.includes('transitCountries')">
                                        The {{ __('Countries of transit') }} field is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Destination country') }}</label>
                                    <div class="form-group">
                                        <select class="form-control"  :class="errors.includes('destinationCountry') ? 'is-invalid' : ''" v-model="destinationCountry" name="destination_country">
                                            <option value="gb">GB - UNITED KINGDOM</option>
                                            <option value="ie">IE - Ireland</option>
                                            <option value="xi">XI - Northern Island</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('destinationCountry')">
                                            The {{ __('Destination country') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Has seal?') }}</label>
                                </div>
                                <div class="form-check d-inline-block mr-4">
                                    <input class="form-check-input" type="radio" value="1" v-model="hasSeal" name="flexRadioDefault"
                                           id="flexRadioDefault1">
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        {{ __('Yes') }}
                                    </label>
                                </div>
                                <div class="form-check d-inline-block">
                                    <input class="form-check-input" type="radio" value="0" v-model="hasSeal" name="flexRadioDefault"
                                           id="flexRadioDefault2" checked>
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        {{ __('No') }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box" v-if="hasSeal == 1">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Seal number') }}</label>
                                    <div class="form-group">
                                        <span class="la la-box form-icon"></span>
                                        <input class="form-control" v-alphanumeric-uppercase :class="errors.includes('sealNumber') ? 'is-invalid' : ''" v-model="sealNumber" type="text" name="seal_number">
                                        <div class="invalid-feedback" v-if="errors.includes('sealNumber')">
                                            The {{ __('Seal number') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold w-100">{{ __('Expected time of arrival in the UK') }}</label>
                                    <div class="form-group w-25 d-inline-block">
                                        <input class="form-control" :class="errors.includes('arrivalDate') ? 'is-invalid' : ''" v-model="arrivalDate" type="date" name="arrival_date">
                                        <div class="invalid-feedback d-table-cell" v-if="errors.includes('arrivalDate')">
                                            The {{ __('Expected time of arrival in the UK') }} field is required.
                                        </div>
                                    </div>
                                    <div class="form-group w-25 d-inline-block">
                                        <input class="form-control" :class="errors.includes('arrivalTime') || errors.includes('arrivalTimeTooSoon') ? 'is-invalid' : ''" v-model="arrivalTime" type="time" name="arrival_time">
                                        <div class="invalid-feedback d-table-cell" v-if="errors.includes('arrivalTime')">
                                            The {{ __('Expected time of arrival in the UK') }} field is required.
                                        </div>
                                        <div class="invalid-feedback d-table-cell" v-if="errors.includes('arrivalTimeTooSoon')">
                                            The {{ __('Expected time of arrival in the UK') }} field is too soon.
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 6" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Buyer') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-12 responsive-column">
                                <div class="input-box">
                                    <label class="label-text font-weight-bold">&nbsp;</label>
                                    <div class="form-group w-75 d-inline-block">
                                        <select class="form-control"  :class="errors.includes('buyer') ? 'is-invalid' : ''" v-model="buyer" name="buyer">
                                            <option value="0">{{ __('Choose') }}</option>
                                            <option v-for="company in buyers" :value="company.id">{{ company.name }} | {{ company.postcode }} {{ company.city }} {{ company.address }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('buyer')">
                                            The {{ __('Buyer') }} field is required.
                                        </div>
                                    </div>
                                    <button class="theme-btn theme-btn-small theme-btn-gray" @click="addNewBuyer">+</button>
                                </div>
                            </div>
                            <div class="col-lg-12 responsive-column" v-if="newBuyer">
                                <div class="row">
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label class="label-text font-weight-bold">{{ __('Company name') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('buyer_company_name') ? 'is-invalid' : ''" v-model="buyer_company_name" type="text" name="buyer_company_name">
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_company_name')">
                                                    The {{ __('Company name') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label class="label-text required font-weight-bold">{{ __('Country') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <select class="form-control" :class="errors.includes('buyer_country') ? 'is-invalid' : ''" v-model="buyer_country" name="buyer_country">
                                                    <option value="gb">GB - UNITED KINGDOM</option>
                                                    <option value="ie">IE - Ireland</option>
                                                    <option value="xi">XI - Northern Island</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_country')">
                                                    The {{ __('Country') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text font-weight-bold">{{ __('Postcode') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('buyer_postcode') ? 'is-invalid' : ''" v-model="buyer_postcode" type="text" name="buyer_postcode">
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_postcode')">
                                                    The {{ __('Postcode') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text font-weight-bold">{{ __('Address line 1') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space-dash :class="errors.includes('buyer_address') ? 'is-invalid' : ''" v-model="buyer_address" type="text" name="buyer_address">
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_address')">
                                                    The {{ __('Address line 1') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text  font-weight-bold">{{ __('Town/City') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('buyer_city') ? 'is-invalid' : ''" v-model="buyer_city" type="text" name="buyer_city">
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_city')">
                                                    The {{ __('Town/City') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box" :class="buyerEORIRequired ? 'required' : ''">
                                            <label
                                                class="label-text font-weight-bold">{{ __('EORI number') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" :class="errors.includes('buyer_eori_number') ? 'is-invalid' : ''" v-model="buyer_eori_number" type="text" name="buyer_eori_number">
                                                <div class="invalid-feedback" v-if="errors.includes('buyer_eori_number')">
                                                    The {{ __('EORI number') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 responsive-column">
                                        <div class="input-box text-right">
                                            <button class="theme-btn theme-btn-gray" @click="cancelNewBuyer">{{ __('Cancel') }}</button>
                                            <button class="theme-btn theme-btn-success ml-3" @click="saveBuyer">{{ __('Save') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 7" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Seller') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-12 responsive-column">
                                <div class="input-box">
                                    <label class="label-text font-weight-bold">&nbsp;</label>
                                    <div class="form-group w-75 d-inline-block">
                                        <select class="form-control" :class="errors.includes('seller') ? 'is-invalid' : ''" v-model="seller" name="seller">
                                            <option value="0">{{ __('Choose') }}</option>
                                            <option v-for="company in sellers" :value="company.id">{{ company.name }} | {{ company.postcode }} {{ company.city }} {{ company.address }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('seller')">
                                            The {{ __('Seller') }} field is required.
                                        </div>
                                    </div>
                                    <button class="theme-btn theme-btn-small theme-btn-gray" @click="addNewSeller">+</button>
                                </div>
                            </div>
                            <div class="col-lg-12 responsive-column" v-if="newSeller">
                                <div class="row">
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label class="label-text font-weight-bold">{{ __('Company name') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('seller_company_name') ? 'is-invalid' : ''" v-model="seller_company_name" type="text" name="seller_company_name">
                                                <div class="invalid-feedback" v-if="errors.includes('seller_company_name')">
                                                    The {{ __('Company name') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label class="label-text required font-weight-bold">{{ __('Country') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <select class="form-control" :class="errors.includes('seller_country') ? 'is-invalid' : ''" v-model="seller_country" name="seller_country">
                                                    <option value="">{{ __('Choose') }}</option>
                                                    <option v-for="country in countries" :value="country.short_code">{{ country.name }}</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.includes('seller_country')">
                                                    The {{ __('Country') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text font-weight-bold">{{ __('Postcode') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('seller_postcode') ? 'is-invalid' : ''" v-model="seller_postcode" type="text" name="seller_postcode">
                                                <div class="invalid-feedback" v-if="errors.includes('seller_postcode')">
                                                    The {{ __('Postcode') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text font-weight-bold">{{ __('Address line 1') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space-dash :class="errors.includes('seller_address') ? 'is-invalid' : ''" v-model="seller_address" type="text" name="seller_address">
                                                <div class="invalid-feedback" v-if="errors.includes('seller_address')">
                                                    The {{ __('Address line 1') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box required">
                                            <label
                                                class="label-text  font-weight-bold">{{ __('Town/City') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" v-alphanumeric-space :class="errors.includes('seller_city') ? 'is-invalid' : ''" v-model="seller_city" type="text" name="seller_city">
                                                <div class="invalid-feedback" v-if="errors.includes('seller_city')">
                                                    The {{ __('Town/City') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 responsive-column">
                                        <div class="input-box">
                                            <label
                                                class="label-text font-weight-bold">{{ __('EORI number') }}</label>
                                            <div class="form-group">
                                                <span class="la la-box form-icon"></span>
                                                <input class="form-control" :class="errors.includes('seller_eori_number') ? 'is-invalid' : ''" v-model="seller_eori_number" type="text" name="seller_eori_number">
                                                <div class="invalid-feedback" v-if="errors.includes('seller_eori_number')">
                                                    The {{ __('EORI number') }} field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 responsive-column">
                                        <div class="input-box text-right">
                                            <button class="theme-btn theme-btn-gray" @click="cancelNewSeller">{{ __('Cancel') }}</button>
                                            <button class="theme-btn theme-btn-success ml-3" @click="saveSeller">{{ __('Save') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 8" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Paying') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Are transport charges being paid by invoice?') }}</label>
                                </div>
                                <div class="form-check d-inline-block mr-4">
                                    <input v-model="paidByInvoice" value="1" class="form-check-input" type="radio" name="flexRadioDefault"
                                           id="flexRadioDefault1">
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        {{ __('Yes') }}
                                    </label>
                                </div>
                                <div class="form-check d-inline-block">
                                    <input v-model="paidByInvoice" value="0" class="form-check-input" type="radio" name="flexRadioDefault"
                                           id="flexRadioDefault2" checked>
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        {{ __('No') }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box" v-if="paidByInvoice == 0">
                                    <label class="label-text font-weight-bold">{{ __('Transport charge') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" :class="errors.includes('charge') ? 'is-invalid' : ''" v-model="charge" name="charge">
                                            <option value="0">{{ __('Choose') }}</option>
                                            <option v-for="item in charges" :value="item.code">{{ item.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('charge')">
                                            The {{ __('Transport charge') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 8" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Transport document') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box required">
                                    <label class="label-text font-weight-bold">{{ __('Type') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" :class="errors.includes('documentType') ? 'is-invalid' : ''" v-model="documentType" name="document_type">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="type in documentTypes" :value="type.code">{{ type.code }} {{ type.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.includes('documentType')">
                                            The {{ __('Type') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Number') }}</label>
                                    <div class="form-group">
                                        <span class="la la-ticket form-icon"></span>
                                        <input class="form-control" v-alphanumeric-uppercase :class="errors.includes('documentNumber') ? 'is-invalid' : ''" v-model="documentNumber" type="text" name="document_number">
                                        <div class="invalid-feedback" v-if="errors.includes('documentNumber')">
                                            The {{ __('Number') }} field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 9" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Trailer totals') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Packages') }}</label>
                                    <div class="form-group">
                                        <span class="la la-boxes form-icon"></span>
                                        <input class="form-control" type="text" name="trailer_packages" value="0" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Gross weight (kg)') }}</label>
                                    <div class="form-group">
                                        <span class="la la-weight-hanging form-icon"></span>
                                        <input class="form-control" type="text" name="trailer_gross_weight" value="0" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 9" class="row">
            <div class="col-lg-12">
                <div class="form-title-wrap">
                    <h3 class="title">{{ __('Consignment total') }}</h3>
                </div>
                <div class="form-box">
                    <div class="form-content">
                        <div class="contact-form-action row">
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Packages') }}</label>
                                    <div class="form-group">
                                        <span class="la la-boxes form-icon"></span>
                                        <input class="form-control" type="text" name="packages_number" :value="totalPackages" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Gross weight (kg)') }}</label>
                                    <div class="form-group">
                                        <span class="la la-weight-hanging form-icon"></span>
                                        <input class="form-control" type="text" name="packages_weight" :value="totalGrossWeight" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-for="(item, index) in packages">
                            <div class="col-lg-2 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Item') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="" :value="index+1" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-10 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Package type') }}</label>
                                    <div class="form-group">
                                        <select class="form-control" v-model="packages[index].packageType">
                                            <option value="">{{ __('Choose') }}</option>
                                            <option v-for="type in packageTypes" :value="type.id">{{ type.code }} {{ type.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('No. of packages') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" :class="errors.includes('package_'+index+'_no_of_packages') ? 'is-invalid' : ''" type="text" v-model="packages[index].noOfPackages" >
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Commodity code (Only the first 4 digits)') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" :class="errors.includes('package_'+index+'_commodity_code') ? 'is-invalid' : ''" type="text" v-model="packages[index].commodityCode" @blur="checkCommodityCode(index)" >
                                        <div class="invalid-feedback" v-if="errors.includes('package_'+index+'_commodity_code')">
                                            {{ __('Invalid commodity code') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Goods desc.') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" v-alphanumeric-space :class="errors.includes('package_'+index+'_goods_description') ? 'is-invalid' : ''" type="text"  v-model="packages[index].goodsDescription" maxlength="50" >
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box required">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Gross weight') }} (kg)</label>
                                    <div class="form-group">
                                        <input class="form-control" :class="errors.includes('package_'+index+'_gross_weight') ? 'is-invalid' : ''" type="text" v-model="packages[index].grossWeight" >
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('Marks and numbers') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" v-alphanumeric-uppercase type="text" v-model="packages[index].marksAndNumbers" >
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="input-box">
                                    <label
                                        class="label-text font-weight-bold">{{ __('UN DG code') }}</label>
                                    <div class="form-group">
                                        <input class="form-control" v-alphanumeric-uppercase type="text" v-model="packages[index].unDgCode" >
                                    </div>
                                </div>
                            </div>
                            <button class="theme-btn theme-btn-small theme-btn-gray" @click="addPackage">+</button>
                            <button v-if="index > 0" class="theme-btn theme-btn-small theme-btn-gray" @click="removePackage(index)">-</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div  v-if="lastStep" class="col-lg-12 text-center">
                <button class="theme-btn theme-btn-gray" @click="cancel">{{ __('Cancel') }}</button>
                <button class="theme-btn ml-3 theme-btn-success" @click="prevStep">{{ __('Previous Step') }}</button>
                <!--<button class="theme-btn ml-3" @click="saveAndNew">{{ __('Save and Add new') }}</button>-->
                <button class="theme-btn theme-btn-success ml-3" @click="saveAndPay">{{ __('Complete') }}</button>
            </div>
            <div  v-if="!lastStep" class="col-lg-12 text-center">
                <button class="theme-btn theme-btn-gray" @click="cancel">{{ __('Cancel') }}</button>
                <button class="theme-btn ml-3 theme-btn-success" v-if="step !== 1" @click="prevStep">{{ __('Previous Step') }}</button>
                <button class="theme-btn theme-btn-success ml-3" @click="nextStep">{{ __('Next Step') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ENS",

    props: {
        listPageUrl: {
            type: String,
        },
        ensOrder: {
            type: Object,
        }
    },

    data() {
        return {
            ensNumber: '',
            type: true,
            subType: 'RORO',
            vehicleNumber: '',
            trailerNumber: '',
            containerNumber: '',
            hasContainerNumber: 0,
            nationalityOfVehicle: '',
            ferryEurotunnelCrossing: '',
            unaccompaniedTrailer: 0,
            paidByInvoice: 1,
            charge: 0,
            countries: [],
            charges: [],
            documentTypes: [],
            documentType: '830',
            documentNumber: '',
            packageTypes: [],
            packages: [{packageType: 1, noOfPackages: 1, commodityCode: '', goodsDescription: '', grossWeight: 0, marksAndNumbers: '', unDgCode: ''}],
            routes: [],
            step: 1,
            steps: 9,
            carrier: 0,
            carriers: [],
            newCarrier: false,
            carrier_company_name: '',
            carrier_country: '',
            carrier_postcode: '',
            carrier_address: '',
            carrier_city: '',
            carrier_eori_number: '',
            newBuyer: false,
            buyer: 0,
            buyers: [],
            buyer_company_name: '',
            buyer_country: '',
            buyer_postcode: '',
            buyer_address: '',
            buyer_city: '',
            buyer_eori_number: '',
            newSeller: false,
            seller: 0,
            sellers: [],
            seller_company_name: '',
            seller_country: '',
            seller_postcode: '',
            seller_address: '',
            seller_city: '',
            seller_eori_number: '',
            eoriNumber: '',
            loadingCountry: '',
            loadingPostcode: '',
            loadingAddress: '',
            unloadingCountry: '228',
            unloadingPostcode: '',
            unloadingAddress: '',
            dispatchCountry: '',
            transitCountries: [{0: ''}],
            destinationCountry: 'gb',
            hasSeal: 0,
            sealNumber: '',
            arrivalDate: '',
            arrivalTime: '',
            errors: [],
            status: 'draft'
        };
    },

    mounted() {
        this.step = 1;
        this.countries = this.loadCountries();
        this.routes = this.loadRoutes();
        this.charges = this.loadCharges();
        this.documentTypes = this.loadDocumentTypes();
        this.packageTypes = this.loadPackageTypes();
        this.carriers = this.loadCarriers();
        this.buyers = this.loadBuyers();
        this.sellers = this.loadSeller();

        if(this.ensOrder) {
            this.ensNumber = this.ensOrder.customer_reference;
            this.type = this.ensOrder.type;
            this.subType = this.ensOrder.sub_type;
            this.status = this.ensOrder.status;
            this.vehicleNumber = this.ensOrder.vehicle_number;
            this.trailerNumber = this.ensOrder.trailer_number;
            this.containerNumber = this.ensOrder.container_number;
            this.hasContainerNumber = this.ensOrder.container_number ? 1 : 0;
            this.containerNumber = this.ensOrder.container_number;
            this.unaccompaniedTrailer = this.ensOrder.unaccompanied_trailer ?? 0;
            this.nationalityOfVehicle = this.ensOrder.nationality_of_vehicle;
            this.ferryEurotunnelCrossing = this.ensOrder.route_id;
            this.arrivalDate = this.ensOrder.expected_date;
            this.arrivalTime = this.ensOrder.expected_time;
            this.carrier = this.ensOrder.carrier_id ?? 0;
            this.loadingCountry = this.ensOrder.loading_country ?? '';
            this.loadingPostcode = this.ensOrder.loading_postcode ?? '';
            this.loadingAddress = this.ensOrder.loading_address ?? '';
            this.unloadingCountry = this.ensOrder.unloading_country ?? '';
            this.unloadingPostcode = this.ensOrder.unloading_postcode ?? '';
            this.unloadingAddress = this.ensOrder.unloading_address ?? '';
            this.dispatchCountry = this.ensOrder.dispatch_country ?? '';
            this.transitCountries = this.ensOrder.ens_routing_id ?? [{0: ''}];
            this.destinationCountry = this.ensOrder.destination_country ?? '';
            this.hasSeal = this.ensOrder.seal_number ?? 0;
            this.sealNumber = this.ensOrder.seal_number ?? '';
            this.documentType = this.ensOrder.document_type ?? '730';
            this.documentNumber = this.ensOrder.document_number ?? '';
            this.charge = this.ensOrder.charge ?? 0;
            this.seller = this.ensOrder.partner_id ?? 0;
            this.buyer = this.ensOrder.uk_trader_id ?? 0;
            if(this.ensOrder.packages && this.ensOrder.packages.length) {
                this.packages = [];
                this.ensOrder.packages.forEach((item, index) => {
                    this.packages.push({
                        packageType: item.package_type_id ?? 0,
                        noOfPackages: item.number_of_packages ?? 1,
                        commodityCode: item.commodity_code ?? '',
                        goodsDescription: item.goods_description ?? '',
                        grossWeight: item.gross_weight ?? 0,
                        marksAndNumbers: item.marks_and_numbers ?? '',
                        unDgCode: item.un_dg_code ?? ''
                    });
                });
            } else {
                this.packages = [{packageType: 0, noOfPackages: 1, commodityCode: '', goodsDescription: '', grossWeight: 0, marksAndNumbers: '', unDgCode: ''}];
            }
        }
    },

    methods: {
        init() {
            this.ensNumber = '';
            this.type = true;
            this.subType = 'RORO';
            this.vehicleNumber = '';
            this.trailerNumber = '';
            this.containerNumber = '';
            this.hasContainerNumber = 0;
            this.nationalityOfVehicle = '';
            this.ferryEurotunnelCrossing = '';
            this.unaccompaniedTrailer = 0;
            this.paidByInvoice = 1;
            this.charge = 0;
            this.documentType = '830';
            this.documentNumber = '';
            this.packages = [{packageType: 1, noOfPackages: 1, commodityCode: '', goodsDescription: '', grossWeight: 0, marksAndNumbers: '', unDgCode: ''}];
            this.step = 1;
            this.carrier = 0;
            this.newCarrier = false;
            this.carrier_company_name = '';
            this.carrier_country = '';
            this.carrier_postcode = '';
            this.carrier_address = '';
            this.carrier_city = '';
            this.carrier_eori_number = '';
            this.newBuyer = false;
            this.buyer = 0;
            this.buyer_company_name = '';
            this.buyer_country = '';
            this.buyer_postcode = '';
            this.buyer_address = '';
            this.buyer_city = '';
            this.buyer_eori_number = '';
            this.newSeller = false;
            this.seller = 0;
            this.seller_company_name = '';
            this.seller_country = '';
            this.seller_postcode = '';
            this.seller_address = '';
            this.seller_city = '';
            this.seller_eori_number = '';
            this.eoriNumber = '';
            this.loadingCountry = '';
            this.loadingPostcode = '';
            this.loadingAddress = '';
            this.unloadingCountry = 'gb';
            this.unloadingPostcode = '';
            this.unloadingAddress = '';
            this.dispatchCountry = '';
            this.transitCountries = [{0: ''}];
            this.destinationCountry = 'gb';
            this.hasSeal = 0;
            this.sealNumber = '';
            this.arrivalDate = '';
            this.arrivalTime = '';
            this.errors = [];
            this.status = 'draft';
        },
        cancel() {
            if(this.ensNumber === ''){
                this.init();
                window.location.href = this.listPageUrl;
            } else {
                this.status = 'cancel';
                this.save();
                this.init();
                window.location.href = this.listPageUrl;
            }
        },
        save(redirect = false) {
            axios.post('/api/ens/save', this.$data)
                .then(response => {
                    console.log(response.data);
                    this.ensNumber = response.data.data.customer_reference;
                    this.errors = [];
                    if(redirect){
                        window.location.href = this.listPageUrl;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.errors.push('error');
                });
            console.log('Save');
        },
        saveAndNew() {
            this.validateStep();
            if(this.errors.length == 0) {
                this.status = 'draft';
                this.save();
                if(this.errors.length == 0){
                    this.init();
                    this.step = 1;
                }
            }
        },
        saveAndPay() {
            this.validateStep();
            if(this.errors.length == 0) {
                this.status = 'pending';
                this.save(true);
            }
        },
        nextStep() {
            this.validateStep();
            if(this.errors.length == 0) {
                this.save();
                if(this.errors.length == 0){
                    this.step++;
                }
            }
        },
        prevStep() {
            this.validateStep();
            if(this.errors.length == 0) {
                this.save();
                if(this.errors.length == 0){
                    this.step--;
                }
            }
        },
        loadCountries() {
            axios.get('/api/ens/countries')
                .then(response => {
                    this.countries = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadRoutes() {
            axios.get('/api/ens/routes')
                .then(response => {
                    this.routes = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadCharges() {
            console.log('Load charges');
            axios.get('/api/ens/charges')
                .then(response => {
                    this.charges = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadDocumentTypes() {
            console.log('Load document types');
            axios.get('/api/ens/transport-document-types')
                .then(response => {
                    this.documentTypes = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadPackageTypes() {
            console.log('Load package types');
            axios.get('/api/ens/package-types')
                .then(response => {
                    this.packageTypes = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadCarriers() {
            console.log('Load carriers');
            axios.get('/api/ens/carriers')
                .then(response => {
                    this.carriers = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadBuyers() {
            console.log('Load buyers');
            axios.get('/api/ens/buyers')
                .then(response => {
                    this.buyers = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadSeller() {
            console.log('Load sellers');
            axios.get('/api/ens/sellers')
                .then(response => {
                    this.sellers = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        __(text){
            return text;
        },
        addNewCarrier() {
            this.newCarrier = true;
        },
        cancelNewCarrier() {
            this.newCarrier = false;
        },
      validateCarrier() {
          this.carrier_country.trim() === "" ? this.errors.push('carrier_country') : this.errors = this.errors.filter(item => item !== 'carrier_country');
          this.carrier_company_name.trim() === "" ? this.errors.push('carrier_company_name') : this.errors = this.errors.filter(item => item !== 'carrier_company_name');
          this.carrier_postcode.trim() === "" ? this.errors.push('carrier_postcode') : this.errors = this.errors.filter(item => item !== 'carrier_postcode');
          this.carrier_city.trim() === "" ? this.errors.push('carrier_city') : this.errors = this.errors.filter(item => item !== 'carrier_city');
          this.carrier_address.trim() === "" ? this.errors.push('carrier_address') : this.errors = this.errors.filter(item => item !== 'carrier_address');
      },
      saveCarrierData() {
        if(this.errors.length == 0) {
          axios.post('/api/ens/save-carrier', {
            name: this.carrier_company_name,
            country: this.carrier_country,
            postcode: this.carrier_postcode,
            address: this.carrier_address,
            city: this.carrier_city,
            eori_number: this.carrier_eori_number
          })
              .then(response => {
                console.log(response.data);
                if(response.data.status === 'success'){
                  this.carrier = response.data.data.id;
                  this.errors = [];
                  this.newCarrier = false;
                  this.loadCarriers();
                } else {
                  this.errors.push('error');
                }
              })
              .catch(error => {
                console.log(error);
                this.errors.push('error');
              });
        }
      },
        saveCarrier() {
            if(this.carrier_eori_number.trim() === ""){
                this.validateCarrier();
                this.errors.push('carrier_eori_number');
            } else {
            axios.post('/api/ens/check-eori-number', {eori_number: this.carrier_eori_number})
                .then(response => {
                    let eoriResponse = response.data;
                    if(eoriResponse.status !== 'success'){
                      this.errors.push('carrier_eori_number');
                      this.validateCarrier();
                    } else {
                      this.errors = this.errors.filter(item => item !== 'carrier_eori_number');
                      this.validateCarrier();
                      this.saveCarrierData();
                    }
                })
                .catch(error => {
                  this.errors.push('carrier_eori_number');
                  this.validateCarrier();
                });
            }
        },
        addNewBuyer() {
            this.newBuyer = true;
        },
        cancelNewBuyer() {
            this.newBuyer = false;
        },
        validateBuyer(){
          this.buyer_country.trim() === "" ? this.errors.push('buyer_country') : this.errors = this.errors.filter(item => item !== 'buyer_country');
          this.buyer_company_name.trim() === "" ? this.errors.push('buyer_company_name') : this.errors = this.errors.filter(item => item !== 'buyer_company_name');
          this.buyer_postcode.trim() === "" ? this.errors.push('buyer_postcode') : this.errors = this.errors.filter(item => item !== 'buyer_postcode');
          this.buyer_city.trim() === "" ? this.errors.push('buyer_city') : this.errors = this.errors.filter(item => item !== 'buyer_city');
          this.buyer_address.trim() === "" ? this.errors.push('buyer_address') : this.errors = this.errors.filter(item => item !== 'buyer_address');
        },
        saveBuyerData(){
          if(this.errors.length === 0) {
            axios.post('/api/ens/save-buyer', {
              name: this.buyer_company_name,
              country: this.buyer_country,
              postcode: this.buyer_postcode,
              address: this.buyer_address,
              city: this.buyer_city,
              eori_number: this.buyer_eori_number
            })
                .then(response => {
                  console.log(response.data);
                  if(response.data.status === 'success'){
                    this.buyer = response.data.data.id;
                    this.errors = [];
                    this.newBuyer = false;
                    this.loadBuyers();
                  } else {
                    this.errors.push('error');
                  }
                })
                .catch(error => {
                  console.log(error);
                  this.errors.push('error');
                });
          }
        },
        saveBuyer() {
          if(this.buyer_eori_number.trim() !== ""){
            axios.post('/api/ens/check-eori-number', {eori_number: this.buyer_eori_number})
                .then(response => {
                  let eoriResponse = response.data;
                  if(eoriResponse.status !== 'success'){
                    this.errors.push('buyer_eori_number');
                    this.validateBuyer();
                  } else {
                    this.errors = this.errors.filter(item => item !== 'buyer_eori_number');
                    this.validateBuyer();
                    this.saveBuyerData();
                  }
                })
                .catch(error => {
                  this.errors.push('buyer_eori_number');
                  this.validateBuyer();
                });
          } else {
            this.errors = this.errors.filter(item => item !== 'buyer_eori_number');
            this.validateBuyer();
            this.saveBuyerData();
          }
        },
        addNewSeller() {
            this.newSeller = true;
        },
        cancelNewSeller() {
            this.newSeller = false;
        },
        saveSeller() {
            this.errors = [];
            this.seller_company_name.trim() === "" ? this.errors.push('seller_company_name') : this.errors = this.errors.filter(item => item !== 'seller_company_name');
            this.seller_postcode.trim() === "" ? this.errors.push('seller_postcode') : this.errors = this.errors.filter(item => item !== 'seller_postcode');
            this.seller_city.trim() === "" ? this.errors.push('seller_city') : this.errors = this.errors.filter(item => item !== 'seller_city');
            this.seller_address.trim() === "" ? this.errors.push('seller_address') : this.errors = this.errors.filter(item => item !== 'seller_address');
            //(this.seller_eori_number.trim() === "" || this.checkEoriNumber() === false)  ? this.errors.push('seller_eori_number') : this.errors = this.errors.filter(item => item !== 'seller_eori_number');

            if(this.errors.length == 0) {
                axios.post('/api/ens/save-seller', {
                    name: this.seller_company_name,
                    country: this.seller_country,
                    postcode: this.seller_postcode,
                    address: this.seller_address,
                    city: this.seller_city,
                    eori_number: this.seller_eori_number
                })
                    .then(response => {
                        console.log(response.data);
                        if(response.data.status === 'success'){
                            this.seller = response.data.data.id;
                            this.errors = [];
                            this.newSeller = false;
                            this.loadSeller();
                        } else {
                            this.errors.push('error');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.errors.push('error');
                    });
            }
        },
        validateStep() {
            console.log('Validate step');
            this.errors = [];
            switch (this.step) {
                case 1: {
                    this.vehicleNumber.trim() === "" ? this.errors.push('vehicleNumber') : this.errors = this.errors.filter(item => item !== 'vehicleNumber');
                    this.hasContainerNumber === "1" && this.containerNumber.trim() === "" ? this.errors.push('containerNumber') : this.errors = this.errors.filter(item => item !== 'containerNumber');
                    this.nationalityOfVehicle.trim() === "" ? this.errors.push('nationalityOfVehicle') : this.errors = this.errors.filter(item => item !== 'nationalityOfVehicle');
                    this.ferryEurotunnelCrossing === "" ? this.errors.push('ferryEurotunnelCrossing') : this.errors = this.errors.filter(item => item !== 'ferryEurotunnelCrossing');
                    break;
                }
                case 2: {
                    this.carrier === 0 || this.carrier === "0" ? this.errors.push('carrier') : this.errors = this.errors.filter(item => item !== 'carrier');
                    break;
                }
                case 3 : {
                    this.loadingCountry.trim() === "" ? this.errors.push('loadingCountry') : this.errors = this.errors.filter(item => item !== 'loadingCountry');
                    this.loadingPostcode.trim() === "" ? this.errors.push('loadingPostcode') : this.errors = this.errors.filter(item => item !== 'loadingPostcode');
                    this.loadingAddress.trim() === "" ? this.errors.push('loadingAddress') : this.errors = this.errors.filter(item => item !== 'loadingAddress');
                    break;
                }
                case 4 : {
                    this.unloadingCountry.trim() === "" ? this.errors.push('unloadingCountry') : this.errors = this.errors.filter(item => item !== 'unloadingCountry');
                    this.unloadingPostcode.trim() === "" ? this.errors.push('unloadingPostcode') : this.errors = this.errors.filter(item => item !== 'unloadingPostcode');
                    this.unloadingAddress.trim() === "" ? this.errors.push('unloadingAddress') : this.errors = this.errors.filter(item => item !== 'unloadingAddress');
                    break;
                }
                case 5 : {
                    this.dispatchCountry.trim() === "" ? this.errors.push('dispatchCountry') : this.errors = this.errors.filter(item => item !== 'dispatchCountry');
                    this.transitCountries.includes('') ? this.errors.push('transitCountries') : this.errors = this.errors.filter(item => item !== 'transitCountries');
                    this.destinationCountry.trim() === "" ? this.errors.push('destinationCountry') : this.errors = this.errors.filter(item => item !== 'destinationCountry');
                    this.hasSeal === 1 && this.sealNumber.trim() === "" ? this.errors.push('sealNumber') : this.errors = this.errors.filter(item => item !== 'sealNumber');
                    this.arrivalDate.trim() === "" ? this.errors.push('arrivalDate') : this.errors = this.errors.filter(item => item !== 'arrivalDate');
                    this.arrivalTime.trim() === "" ? this.errors.push('arrivalTime') : this.errors = this.errors.filter(item => item !== 'arrivalTime');
                    if (this.arrivalDate && this.arrivalTime) {
                        const arrivalDateTime = new Date(`${this.arrivalDate}T${this.arrivalTime}`);
                        const currentDateTime = new Date();
                        const timeDifference = (arrivalDateTime - currentDateTime) / (1000 * 60 * 60); // Difference in hours

                        if (timeDifference < 2.5) {
                            this.errors.push('arrivalTimeTooSoon');
                        } else {
                            this.errors = this.errors.filter(item => item !== 'arrivalTimeTooSoon');
                        }
                    }
                    break;
                }
                case 6 : {
                    this.buyer === 0 || this.buyer === "0" ? this.errors.push('buyer') : this.errors = this.errors.filter(item => item !== 'buyer');
                    break;
                }
                case 7 : {
                    this.seller === 0 || this.seller === "0" ? this.errors.push('seller') : this.errors = this.errors.filter(item => item !== 'seller');
                    break;
                }
                case 8 : {
                    this.paidByInvoice === 0 && this.charge === 0 ? this.errors.push('charge') : this.errors = this.errors.filter(item => item !== 'charge');
                    this.documentType === 0 ? this.errors.push('documentType') : this.errors = this.errors.filter(item => item !== 'documentType');
                    this.documentNumber.trim() === "" ? this.errors.push('documentNumber') : this.errors = this.errors.filter(item => item !== 'documentNumber');
                    break;
                }
                case 9 : {
                    this.packages.forEach((item, index) => {
                        item.packageType === 0 ? this.errors.push('package_'+index+'_package_type') : this.errors = this.errors.filter(item => item !== 'package_'+index+'_package_type');
                        item.noOfPackages === 0 ? this.errors.push('package_'+index+'_no_of_packages') : this.errors = this.errors.filter(item => item !== 'package_'+index+'_no_of_packages');
                        item.commodityCode.trim() === "" ? this.errors.push('package_'+index+'_commodity_code') : this.errors = this.errors.filter(item => item !== 'package_'+index+'_commodity_code');
                        item.goodsDescription.trim() === "" ? this.errors.push('package_'+index+'_goods_description') : this.errors = this.errors.filter(item => item !== 'package_'+index+'_goods_description');
                        item.grossWeight === 0 ? this.errors.push('package_'+index+'_gross_weight') : this.errors = this.errors.filter(item => item !== 'package_'+index+'_gross_weight');
                    });
                    break;
                }
            }
        },
        async checkEoriNumber(number) {
            try {
                const response = await axios.post('/api/ens/check-eori-number', {eori_number: number});
                console.log(response.data.status);
                return response.data.status === 'success';
            } catch (error) {
                console.error(error);
                return false;
            }
        },
        checkCommodityCode(index) {
            axios.post('/api/ens/check-commodity-code', {commodity_code: this.packages[index].commodityCode})
                .then(response => {
                    console.log(response.data);
                    if(response.data.status === 'success'){
                        this.errors = this.errors.filter(item => item !== 'package_'+index+'_commodity_code');
                    } else {
                        this.errors.push('package_'+index+'_commodity_code');
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.errors.push('package_'+index+'_commodity_code');
                    return false;
                });
        },
        addTransitCountry() {
            this.transitCountries.push('');
        },
        removeTransitCountry(index) {
            this.transitCountries.splice(index, 1);
        },
        addPackage() {
            this.packages.push({packageType: 1, noOfPackages: 1, commodityCode: '', goodsDescription: '', grossWeight: 0, marksAndNumbers: '', unDgCode: ''});
        },
        removePackage(index) {
            this.packages.splice(index, 1);
        }
    },

    computed: {
        progress() {
            return (this.step / this.steps) * 100;
        },
        lastStep() {
            return this.step === this.steps;
        },
        totalPackages() {
            let totalPackage = 0;
            if(this.packages.length > 0) {
                this.packages.forEach(item => {
                    totalPackage += parseInt(item.noOfPackages);
                });
            }
            return totalPackage;
        },
        totalGrossWeight() {
            let totalGross = 0;
            if(this.packages.length > 0) {
                this.packages.forEach(item => {
                    totalGross += parseFloat(item.grossWeight);
                });
            }
            return totalGross;
        },
        buyerEORIRequired() {
            //return this.buyer_country === 'gb';
          return false;
        },
    }

}
</script>
